import PermitAutomationModal from './PermitAutomationModal';

export default PermitAutomationModal;
